import { render } from "./PageRegister.vue?vue&type=template&id=56b2967c&scoped=true"
import script from "./PageRegister.vue?vue&type=script&lang=js"
export * from "./PageRegister.vue?vue&type=script&lang=js"

import "./PageRegister.vue?vue&type=style&index=0&id=56b2967c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b2967c"]])

export default __exports__